import React from 'react';

export default function IconRunningTrade() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      fill="none"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12.751 2.568h1.901M13.71 10.156v4.258l2.845 2.844M2.336 16.25h3.786M3.278 13h3.787"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M6.368 9.198a9.049 9.049 0 0 1 3.218-2.795 9.002 9.002 0 0 1 10.498 1.625 9.002 9.002 0 0 1 2.632 6.37c0 2.389-.96 4.68-2.633 6.37-1.674 1.69-3.981 2.633-6.37 2.633a8.854 8.854 0 0 1-4.127-1.008 9.027 9.027 0 0 1-3.218-2.795"
      />
    </svg>
  );
}
